import { defineAccept, defineProvide } from "../../common/src/pattern";

/*🤫
🤫
🤫*/
export type TextExpanderAccepts = {
  /*🤫
🤫
🤫*/
  toggle: [data: { expanded?: boolean }];
};

export const ACCEPT = defineAccept<TextExpanderAccepts>({
  toggle: "toggle",
});

/*🤫
🤫
🤫*/
export type TextExpanderProvides = {
  created: [data: { expanded: boolean }];
  /*🤫
🤫
🤫*/
  mounted: [data: { expanded: boolean; hasMoreContentThanDisplayed: boolean }];
  /*🤫
🤫
🤫*/
  toggled: [data: { expanded: boolean; hasMoreContentThanDisplayed: boolean }];
};

export const PROVIDE = defineProvide<TextExpanderProvides>({
  created: "created",
  mounted: "mounted",
  toggled: "toggled",
});
